import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null =>
    !control.value || regex.test(control.value) ? null : error;
}

export function passwordMatchValidator(control: AbstractControl): ValidationErrors | null {
  const password = control.get('newPassword')?.value;
  const confirm = control.get('confirmPassword')?.value;
  return password && confirm && password !== confirm ? { noPasswordMatch: true } : null;
}

export const passwordValidators: ValidatorFn[] = [
  patternValidator(/[A-Z]/, { hasUpper: true }),
  patternValidator(/[a-z]/, { hasLower: true }),
  patternValidator(/\d/, { hasNumber: true }),
  patternValidator(/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/, { hasSpecial: true }),
];

export type PasswordStrengthScore = 0 | 1 | 2 | 3 | 4;

export function passwordStrengthScore(password: string): PasswordStrengthScore {
  if (!password) return 0;
  let score = 0;
  if (password.length >= 8) score++;
  if (password.length >= 12) score++;
  if (/[A-Z]/.test(password) && /[a-z]/.test(password)) score++;
  if (/\d/.test(password)) score++;
  if (/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)) score++;
  return Math.min(score, 4) as PasswordStrengthScore;
}
